import React from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import type {IpiVisClientRank} from './_requests'

type Props = {
  title: string
  badgeLabel: string
  items: IpiVisClientRank[]
  onView: (customerId: number) => void
  variant?: 'compact' | 'stacked'
}

const ViewButton: React.FC<{onClick: () => void}> = ({onClick}) => (
  <button className='ipivis-ranked__view' onClick={onClick} type='button'>
    <img src={toAbsoluteUrl('/media/icons/ipivis/view.svg')} alt='' style={{width: 14, height: 14}} />
    View
  </button>
)

export const RankedClientList: React.FC<Props> = ({
  title,
  badgeLabel,
  items,
  onView,
  variant = 'compact',
}) => {
  return (
    <div className='ipivis-card ipivis-ranked'>
      <div className='ipivis-ranked__title'>{title}</div>
      {items.length === 0 ? (
        <div className='ipivis-empty'>No data for the selected range.</div>
      ) : (
        <ul className={`ipivis-ranked__list ipivis-ranked__list--${variant}`}>
          {items.map((c) =>
            variant === 'stacked' ? (
              <li key={c.customerId} className='ipivis-ranked__row ipivis-ranked__row--stacked'>
                <div className='ipivis-ranked__name' title={c.clientName}>
                  {c.rank}. {c.clientName}
                </div>
                <div className='ipivis-ranked__meta'>
                  <div className='ipivis-ranked__meta-left'>
                    <span className='ipivis-ranked__badge'>
                      {c.count} {badgeLabel}
                    </span>
                    <span className='ipivis-ranked__pct'>{c.percentage}%</span>
                  </div>
                  <ViewButton onClick={() => onView(c.customerId)} />
                </div>
              </li>
            ) : (
              <li key={c.customerId} className='ipivis-ranked__row ipivis-ranked__row--compact'>
                <div className='ipivis-ranked__left'>
                  <span className='ipivis-ranked__name' title={c.clientName}>
                    {c.rank}. {c.clientName}
                  </span>
                  <span className='ipivis-ranked__badge'>
                    {c.count} {badgeLabel}
                  </span>
                  <span className='ipivis-ranked__pct'>{c.percentage}%</span>
                </div>
                <div className='ipivis-ranked__right'>
                  <ViewButton onClick={() => onView(c.customerId)} />
                </div>
              </li>
            )
          )}
        </ul>
      )}
    </div>
  )
}
